export default __webpack_public_path__ + "static/media/user-id-random.cabb65fa.gif";